import * as React from 'react';
import { connect } from 'react-redux';
import './RegisterTab.scss';

import { IInputType, Input } from '@src/components/form/input/Input';
import InnerUiWrap from '@src/components/inner-ui-wrap/InnerUiWrap';
import Button, { IButtonType } from '@src/components/button/Button';
import InnerFooterWrap from '@src/components/inner-footer-wrap/InnerFooterWrap';
import { Utils } from '@src/utils/Utils';
import SmallInfo from '@src/components/small-info/SmallInfo';
import { AppActions } from '@src/actions/AppActions';
import { __ } from '@src/utils/i18Abstract';

interface IReduxState {}

interface IState {
    phoneNumber: string;
    isValid: boolean;
}

interface IReduxActions {
    register: (phoneNumber: string) => void;
}

type IAllProps = IReduxState & IReduxActions;

class RegisterTab extends React.Component<IAllProps, IState> {
    state = {
        phoneNumber: '',
        isValid: true,
    };
    render() {
        const { register } = this.props;
        const { phoneNumber, isValid } = this.state;

        return (
            <div className="RegisterTab-wrap">
                <form
                    onSubmit={e => {
                        e.preventDefault();

                        if (Utils.removeWhitespace(phoneNumber).length !== 8) {
                            return this.setState({ isValid: false });
                        }

                        this.setState({ isValid: true });

                        register(phoneNumber);
                    }}>

                    <InnerUiWrap>
                        <Input
                            label={__('inputPhone')}
                            value={phoneNumber}
                            hasError={!isValid}
                            errorLabel={__('warningProvideValidLVPhone')}
                            type={IInputType.tel}
                            noBottomMargin
                            onChange={val => {
                                const trimmed: string = Utils.removeWhitespace(
                                    Utils.onlyNumeric(val),
                                );

                                if (trimmed.length > 8) {
                                    return;
                                }

                                this.setState({
                                    phoneNumber: trimmed,
                                });
                            }}
                        />

                    </InnerUiWrap>

                    <InnerFooterWrap>
                        <Button
                            fat
                            fullWidth
                            title={__('buttonRegister')}
                            type={IButtonType.submit}
                        />

                        <SmallInfo body={__('legalNewPassword')} />

                    </InnerFooterWrap>

                </form>
            </div>
        );
    }
}

const mapStateToProps = (state: any): IReduxState => {
    return {};
};

const mapDispatchToProps = (dispatch: any): IReduxActions => {
    return {
        register: phoneNumber => dispatch(AppActions.changePin(phoneNumber)),
    };
};

export default connect<IReduxState, IReduxActions, null>(
    mapStateToProps,
    mapDispatchToProps,
)(RegisterTab);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/login-overlay/register-tab/RegisterTab.tsx